
import Vue from 'vue'

interface IData {
  default: any
}

const component = Vue.extend({
  data(): IData {
    return {
      default: {
        class: 'pa-2 pa-md-4 h-full'
      }
    }
  },
  computed: {
    __attrs(): any {
      return {
        ...this.default,
        ...this.$attrs
      }
    }
  }
})

Vue.component('AContainer', component)
export default component
